export class PowerBIEmbed {
  embedToken: string;
  embedUrl: string;
  embedReportId: string;
  embedTokenExpiration: string;
}

export class PowerBICredentials {
  reportName: string;
  reportDescription: string;
  groupId: string;
  reportId: string;
  datasetId: string;
}
